import * as z from 'zod';

export const EventTagSchema = z.object({
  eventId: z.string(),
  tagId: z.string(),
  createdAt: z.coerce.date(),
});

export type EventTagType = z.infer<typeof EventTagSchema>;
